import { TriangleAlert } from 'lucide-react';
import { icon } from '@carvana/ds-styles';
import React, { useEffect, useRef } from 'react';
import telemetryService from '|/app/services/telemetry/telemetry-service';
import { contactAgentNatively } from '|/helpers/native';
import useAnalyticsContext from '|/hooks/use-analytics-context';
import styles from './SchedulingErrorPrompt.module.css';

const ADVOCATE_PHONE = '+18884150885';

const ScheduleErrorPrompt = () => {
  const { trackEvent } = useAnalyticsContext();
  const hasTrackedNoSlotsRef = useRef(false);
  useEffect(() => {
    if (hasTrackedNoSlotsRef.current) return;
    hasTrackedNoSlotsRef.current = true;
    telemetryService.trackEvent({
      name: 'transfer-scheduling:no-available-slots'
    });

    trackEvent('no_available_slots');
  }, [trackEvent]);

  return (
    <div className={styles.container}>
      <div className={styles.contentLockup}>
        <div className={styles.header}>
          <div className={styles.iconContainer}>
            <TriangleAlert color={icon.warning} size={56} />
          </div>
          <div className={styles.headingContainer}>
            <h1 className={styles.title}>There was a scheduling issue</h1>
          </div>
          <p className={styles.description}>
            {`We weren't able to get delivery or pickup times. Please contact our Customer Advocate
            team at `}
            <a
              href={`tel:${ADVOCATE_PHONE}`}
              className={styles.phoneLink}
              data-analytics-id="no_available_slots_phone_number"
              onClick={event => {
                if (contactAgentNatively(ADVOCATE_PHONE, 'purchase')) {
                  event.preventDefault();
                }
              }}
            >
              888-415-0885
            </a>
            {`. We're available 7 days a week from 8 a.m. - 9 p.m. EST.`}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ScheduleErrorPrompt;
